import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "sp-divider"
    }}>{`sp-divider`}</h1>
    <p><strong parentName="p">{`Since:`}</strong>{` UXP v4.1`}</p>
    <p>{`Renders a divider.`}</p>
    <p><img alt="Dividers" src={require("../../assets/sp-divider.png")} /></p>
    <p><strong parentName="p">{`See`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://spectrum.adobe.com/page/rule/"
        }}>{`https://spectrum.adobe.com/page/rule/`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://opensource.adobe.com/spectrum-web-components/components/rule"
        }}>{`https://opensource.adobe.com/spectrum-web-components/components/rule`}</a></li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-divider></sp-divider>
`}</code></pre>
    <h2 {...{
      "id": "sizes"
    }}>{`Sizes`}</h2>
    <p>{`There are three supported sizes.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-divider size="large"></sp-divider>
<sp-divider size="medium"></sp-divider> <!-- default -->
<sp-divider size="small"></sp-divider>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      